import { render, staticRenderFns } from "./FavouriteTutors.vue?vue&type=template&id=5ff5b200&scoped=true"
import script from "./FavouriteTutors.vue?vue&type=script&lang=js"
export * from "./FavouriteTutors.vue?vue&type=script&lang=js"
import style0 from "./FavouriteTutors.vue?vue&type=style&index=0&id=5ff5b200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff5b200",
  null
  
)

export default component.exports